import React from "react";
import styles from "./Empty.module.sass";

const Empthy = ({ title = "Empty" }) => {
	return (
		<div className={styles.container}>
			<div>
				<img src="/images/empty.png" alt="empthy" />
				<div>{title}</div>
			</div>
		</div>
	);
};

export default Empthy;
